// src/services/edge-nodes.js

import api from './api';

// The change starts here: we use 'export const' instead of just 'const'
export const edgeNodesService = {
  getEdgeNodes: async (filters = {}) => {
    try {
      const cleanedFilters = Object.fromEntries(
        Object.entries(filters).filter(([_, value]) => value !== '')
      );
      const response = await api.get('/edge-nodes/', { params: cleanedFilters });
      return response.data;
    } catch (error) {
      console.error('Error fetching edge nodes:', error);
      throw error;
    }
  },
  getEdgeNode: async (nodeId) => {
    try {
      const response = await api.get(`/edge-nodes/${nodeId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching edge node ${nodeId}:`, error);
      throw error;
    }
  },
  registerEdgeNode: async (registrationData) => {
    try {
      const response = await api.post('/edge-nodes/register', registrationData);
      return response.data;
    } catch (error) {
      console.error('Error registering edge node:', error);
      throw error;
    }
  },
  deleteEdgeNode: async (nodeId) => {
    try {
      await api.delete(`/edge-nodes/${nodeId}`);
    } catch (error) {
      console.error(`Error deleting edge node ${nodeId}:`, error);
      throw error;
    }
  },

  updateEdgeNode: async (nodeId, updateData) => {
    try {
      const response = await api.put(`/edge-nodes/${nodeId}`, updateData);
      return response.data;
    } catch (error) {
      console.error(`Error updating edge node ${nodeId}:`, error);
      throw error;
    }
  },

  getAssignedPolicies: async (nodeId) => {
    try {
      // *** ADD THIS LINE TO SEE THE EXACT URL ***
      console.log(`Requesting URL for assigned policies: /edge-nodes/${nodeId}/assigned-policies`);

      const response = await api.get(`/edge-nodes/${nodeId}/assigned-policies`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching assigned policies for node ${nodeId}:`, error);
      throw error;
    }
  },

  sendHeartbeat: async (nodeId, heartbeatData) => {
    try {
      const response = await api.post(`/edge-nodes/${nodeId}/heartbeat`, heartbeatData);
      return response.data;
    } catch (error) {
      console.error(`Error sending heartbeat for node ${nodeId}:`, error);
      throw error;
    }
  },

  assignPolicy: async (nodeId, policyId) => {
    try {
      const response = await api.post(`/edge-nodes/${nodeId}/assign-policy/${policyId}`);
      return response.data;
    } catch (error) {
      console.error(`Error assigning policy ${policyId} to node ${nodeId}:`, error);
      throw error;
    }
  },

  unassignPolicy: async (nodeId, policyId) => {
    try {
      const response = await api.delete(`/edge-nodes/${nodeId}/unassign-policy/${policyId}`);
      return response.data;
    } catch (error) {
      console.error(`Error unassigning policy ${policyId} from node ${nodeId}:`, error);
      throw error;
    }
  }
};

// We NO LONGER need an export default at the end.
